import {constants} from '@/utils/Constants.js'

export const filterFormQuestions = (questions, isCustom = false) => {
  return Object.keys(questions).
    filter((key) => {
      return isCustom ? !constants.LEAD_FORM_PRIMITIVE_QUESTIONS.includes(key) : constants.LEAD_FORM_PRIMITIVE_QUESTIONS.includes(key)
    }).
    reduce((cur, key) => {
      return Object.assign(cur, { [key]: questions[key] })
    }, {})
}
